<script setup>
import { computed, shallowRef, ref } from 'vue'
import { result as _result } from 'lodash-es'
import { storeToRefs } from 'pinia'
import { commons } from '@provise/lib/transformer'

import { useApi } from '@provise/composables/api'

import { useConfigsStore } from '@/stores/configs'

import List from '@provise/components/list/list.vue'
import ListTh from '@provise/components/list/th.vue'

defineEmits(['select', 'filerChanged'])
const props = defineProps({
  filter: {
    type: String,
    default: 'my',
  },
})

const { config } = storeToRefs(useConfigsStore())

const model = shallowRef([])
const tdStyle = ref({})
const lm = ref({})
const rows = computed(() => model.value.data || [])
const total = computed(() => model.value.total_count || 0)

const query = computed(() => {
  const query = { ...lm.value }
  query.onPage = 500
  query.page = 1
  if (props.filter === 'my') {
    query.my_complaints = true
  }
  if (props.filter === 'group') {
    query.group_complaints = true
  }
  return query
})

useApi({
  url: 'complaints',
  query,
  watch: lm,
  model,
  pick: d => {
    d.data = d.data.map(d => {
      d.medicineLabel = commons.medicineLabel(d.medicine)
      d.categoryLabel = requestCategoryLabel(d)
      d.overdue = false

      if (d.current_sla) {
        const fmt = 'yyyy.MM.dd HH:mm'
        d.sla_date_finish = commons.dateLocal(d.current_sla.date_finish)
        if (
          commons.dateLocal(d.current_sla.date_finish, fmt) < commons.dateLocal(new Date(), fmt) &&
          !['closed', 'done'].includes(d.status.key)
        )
          d.overdue = true
      }
      return d
    })
    return d
  },
})

function requestCategoryLabel(d) {
  let cat = d.request_category || {}
  return cat.parent ? `${cat.parent.name} / ${cat.name}` : cat.name
}

const changeTdStyle = isOpen => {
  if (isOpen) {
    tdStyle.value = { position: 'static', mask: 'unset' }
  } else {
    tdStyle.value = {}
  }
}

const columns = [
  { title: 'id', label: '№' },
  {
    title: 'medicineLabel',
    label: 'Лекарственный препарат',
    path: 'medicine.medicine_trademark.name',
  },
  {
    title: 'request_category.parent.name',
    label: 'Категория',
    path: 'request_category.parent.name',
  },
  { title: 'request_category.name', label: 'Тип', path: 'request_category.name' },
  { title: 'sla_date_finish', label: 'Дата завершения этапа', path: 'current_sla.date_finish' },
  { title: 'status.value', label: 'Этап', path: 'status.value' },
  {
    title: 'assign_user',
    label: 'Ответственный',
    path: 'assign_user.username',
    getter: o => o.assign_user?.fio || o.assign_user?.username,
  },
]
</script>
<template>
  <List v-model="lm" :total="total" :pagination="false">
    <div class="scrollable-table mb-3">
      <table class="table table-striped table-hover table-w-controls" style="margin-bottom: auto">
        <thead>
          <tr>
            <ListTh
              v-for="column in columns"
              :key="column.title"
              :cfg="config.customer_category"
              :column-id="column.path || column.title"
              :width="column.width"
              @change-td-style="changeTdStyle"
            >
              {{ column.label }}
            </ListTh>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="row.id"
            class="pointer"
            :class="{ 'text-danger': row.overdue }"
            @click="$router.push({ name: 'complaint.item', params: { id: row.id } })"
          >
            <td v-for="(col, name) in columns" :key="name">
              <div :style="col.width ? 'width:' + col.width : ''">
                <template v-if="col.getter">
                  {{ col.getter(row) }}
                </template>
                <template v-else-if="col.path == 'current_sla.date_finish'">
                  {{ row[col.title] }}
                  <i class="bi bi-exclamation-circle text-danger" v-if="row.overdue" />
                </template>
                <template v-else-if="col.title == 'medicineLabel'">
                  {{ row[col.title] }}
                </template>
                <template v-else-if="col.date && typeof _result(row, col.path) === 'string'">
                  {{ commons.dateLocal(_result(row, col.path)) }}
                </template>
                <template v-else>
                  {{ _result(row, col.path || col.title) }}
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </List>
</template>
